import MainSharedComponent from "@components/severalbrands/ourStoryPage/mainSharedComponent";
import { DomainInfo } from "@components/severalbrands/utils/services";
const list = [
    {
        img: "/severalbrands/assets/images/unlockingBusinessImg2.png",
        mainTitle: "A Multi-Channel Lead Generation Engine",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "Search Engine Marketing gets you immediate visibility and precise targeting, reaching decision-makers right when they search. SEO builds organic trust and authority over time, often paying off well beyond the initial campaign. We run both together: quick wins through paid media on Google, Bing, and Yahoo, backed by a dedicated content team and SEM account managers, while organic search builds sustainable, long-term visibility.",
        ],
        imgToLeft: true,
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#37367D] lg:mt-[50px] 3xl:mt-0",
        secondTitleClassName: "mt-[20px]",
        imgClassName:
            "w-[250px]  h-[200px] md:w-[470px] md:min-w-[470px] md:h-[504px] relative 3xl:w-[670px] 3xl:min-w-[670px] 3xl:h-[604px] 3xl:mt-10 lg:ml-16 3xl:ml-28",
    },

    {
        img: "/severalbrands/assets/images/displayAdvertisingImg2.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "Our display campaigns reach contextually relevant audiences at scale through the Google Display Network, Taboola, Outbrain, PPV, and other networks. Over the past decade, we've fine-tuned this approach to prioritize conversion over simple impressions, so your display spend delivers leads, not just views.",
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,

        mainTitleClassName: "text-[#37367D] lg:mt-[60px]",

        imgClassName:
            "w-[250px]  h-[200px] md:w-[430px] md:min-w-[430px] md:h-[354px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]",
    },

    {
        img: "/severalbrands/assets/images/localizationImg2.png",
        mainTitle: "Localization",
        paragraphs: [
            "Localization goes beyond translation, it adapts imagery, currency, messaging, and user experience to local cultural norms. Law firms reaching Spanish-speaking clients and software companies with international audiences both see stronger engagement when campaigns are built around local context rather than a single scaled template.",
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "lg:mt-12",
        mainTitleClassName: "text-[#37367D] lg:mt-[100px]",
        imgToLeft: true,
        imgClassName:
            "w-[250px]  h-[200px] md:w-[418px] md:min-w-[418px] 3xl:w-[618px] 3xl:min-w-[618px] 3xl:h-[730px] md:h-[530px] relative lg:ml-16 3xl:ml-28",
    },
];

export default function MiddleSection({
    domainInfo,
}: {
    domainInfo: DomainInfo;
}) {
    return (
        <section className={`lg:mt-[167px] mt-[100px] `}>
            {list.map((el, index) => (
                <div className="lg:mt-36 mt-14 first-of-type:mt-0 " key={index}>
                    <MainSharedComponent info={el} domainInfo={domainInfo} />
                </div>
            ))}
        </section>
    );
}
